import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/IconButton": IconButton, "@mui/material/Icon": Icon } } });
export default ClientProvider;
